import React from 'react';
import { cx } from './cx';
import { filterChipClass } from './FilterChips';
import { playClickSound } from '@/utils/soundUtils';

export interface FilterChipProps {
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
  /** Pill (default) or rounded box — matches games toolbar controls. */
  shape?: 'pill' | 'box';
  /** Box only — fixed width so short labels (PLAY, All, HOT) align. */
  uniform?: boolean;
  /** Skip automatic click sound. */
  silent?: boolean;
  'aria-label'?: string;
}

/** One toggle chip with the same look as `FilterChips` (for chips that are not a plain value group). */
export default function FilterChip({
  active,
  onClick,
  children,
  className,
  shape = 'pill',
  uniform = false,
  silent = false,
  'aria-label': ariaLabel,
}: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        if (!silent) playClickSound();
        onClick?.(e);
      }}
      aria-pressed={active}
      aria-label={ariaLabel}
      className={cx(
        filterChipClass(!!active, shape),
        'shrink-0 justify-center gap-1.5 whitespace-nowrap font-ui',
        shape === 'box' && (uniform ? 'w-21 min-w-21' : 'min-w-21'),
        className
      )}
    >
      {children}
    </button>
  );
}
